import Model from './BaseModel';
import MarketGroupSet from './MarketGroupSet';

export default class Competition extends Model {
	resourceName() {
		return 'competitions';
	}

	fields() {
		return [
			'name',
			'classification',
			'featured',
			'featured_order',
			'is_manual',
			'visible',
			'remote_id',
			'start_time',
			'sportcast_competition_id',
			'fees',
			'cashout_enabled'
		];
	}

	relationships() {
		return {
			market_group_set: new MarketGroupSet()
		};
	}

	updateSportcastCompetition(data) {
		return this.makePersistRequest({
			url: `${this.resourceName()}/${this.id}/sportcast_competition`,
			method: 'PATCH',
			data
		});
	}
	deleteSportcastCompetition() {
		return this.makePersistRequest({
			url: `${this.resourceName()}/${this.id}/sportcast_competition`,
			method: 'DELETE'
		});
	}
}
